import React, { forwardRef, useEffect, useState } from "react";
import { Button, Space } from 'antd';
import { PlusCircleOutlined } from "@ant-design/icons";

import QueryFilter from "./QueryFilter";


const TableToolFilterComponent = ({ mapDiv, mapView, queries, addQuery, mapLayer, sublayer, featureLayer, columnValues,  featureTable}) => {

    /**
     * Funcion que añade una nueva query agregada por el usuario.
     * Por ahora solo se usa la key
     */
    const addNewQuery = () => {
        let object = {
            key: undefined,
            columna: "",
            queryParam: ""
        }
        object.key = Math.random().toString(36).slice(-6);
        object.name = 'NOMBRE'
        object.content = "es"
        let copyQueries = [...queries];
        copyQueries.push(object)
        //console.log('queries', copyQueries)
        addQuery(copyQueries);
    }

    /**
     * Funcion que añade las queries con los valores seleccionados o introducidos por el usuario
     */
    const modifyQuery = (id, nameValue, contentValue) => {
        let copyQueries = [...queries];
        copyQueries.map(query => {
            if (query.key == id) {
                query.name = nameValue
                query.content = contentValue
            } else {
                return query
            }
        });
        addQuery(copyQueries);
    }

    /**
     * Funcion para eliminar la query al clicar el botón de eliminar
     */
    const removeQuery = (id) => {
        let copyQueries = [...queries];
        const queriesFiltradas = copyQueries.filter(query => query.key != id);
        addQuery(queriesFiltradas);
    }
    return (
        <>
            <div style={{ userSelect: 'text', marginBottom: '20px' }}>
                <Button onClick={(e) => { addNewQuery() }}><PlusCircleOutlined /></Button> Agregar expresión
            </div>
        
            <Space direction="vertical" size="small" style={{ display: 'flex' }}>
                {queries.map((query) => {
                    return (
                        <>
                            <QueryFilter
                                key={query.key}
                                id={query.key}
                                mapDiv={mapDiv}
                                mapView={mapView}
                                columnaProp={query.name}
                                queryParamProp={query.content}
                                mapLayer={mapLayer}
                                sublayer={sublayer}
                                featureLayer={featureLayer}
                                columnValues={columnValues}
                                modifyQuery={modifyQuery}
                                removeQuery={removeQuery}
                                featureTable={featureTable}>
                            </QueryFilter>
                        </>
                    );
                })}
            </Space>
        </>
    );
};

export default TableToolFilterComponent;